import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import i18n from "./i18n";
import vuetify from "./plugins/vuetify";
import base from "./plugins/base";
import { installGlobals } from "./plugins/globals";
import "./plugins/firebase";
import VueApexCharts from "vue3-apexcharts";
import VueGtag from "vue-gtag";

const app = createApp(App);

installGlobals(app);

app.use(store);
app.use(router);
app.use(i18n);
app.use(vuetify);
app.use(base);
app.use(VueApexCharts);
app.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_ID },
}, router);

// The former global mixin (vuetify-multiple-draggable-dialogs) is Vue 2 only.
// Provide a no-op so existing calls to activateMultipleDraggableDialogs() keep
// working. Dialogs render normally; drag behaviour can be reintroduced later.
app.mixin({
  methods: {
    activateMultipleDraggableDialogs() {},
    // Vuetify 3 data-table headers use { title, key } instead of { text, value }.
    // This normalizes existing header definitions without touching each one.
    normalizeHeaders(headers) {
      if (!Array.isArray(headers)) return headers;
      return headers.map((h) => ({
        ...h,
        title: h.title !== undefined ? h.title : h.text,
        key: h.key !== undefined ? h.key : h.value,
      }));
    },
  },
});

app.mount("#app");
